module.exports = __webpack_public_path__ + "@/assets/img/doc.4ad58751.svg";